<ngx-smart-modal #myModal1 identifier="myModal1">
   <h2 class="modalError">Please login and subscribe to access this content.</h2>
   <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
 </ngx-smart-modal>
<!-- <!-- <ngx-smart-modal #myModal2 identifier="myModal2">
   <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
   <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
 </ngx-smart-modal> --><div class="loadingBox" *ngIf="!loaded">
   <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
  </div>
 <div *ngIf="!otpSent">
        <section class="login-main-wrapper">
                <div class="container-fluid pl-0 pr-0">
                   <div class="row no-gutters row justify-content-center">
                      <div class="col-md-5 p-5 bg-dark-style full-height">
                          <div class="text-center mb-5 login-main-left-header">
                              <img src="assets/img/hostbrand/core-logo.svg" width="200" class="img-fluid" alt="LOGO">
                              
                                </div>
                           <div class="row">
                                        <div class="col-sm-12">
                                                <form name="sample-form" #f="ngForm">
                                                        <div *ngIf="!hideUsername" class="form-group">
                                                        <label i18n="@@Mobile Number | Mobile Number Label">Mobile number</label><br/>
                                                <international-phone-number #mobNumText [(ngModel)]="mobNum" (change)="onMobNumKeyUp($event)" placeholder="Enter phone number" i18n-placeholder="Enter Phone Number" [maxlength]="20"  [required]="true" [defaultCountry]="'za'" #phoneNumber="ngModel" name="phone_number"  [allowedCountries]="['za','tn', 'eg', 'dz', 'kw', 'ae', 'ng']"></international-phone-number>
                                                
                                                 <div *ngIf="f.submitted && !phoneNumber.valid" i18n="@@Phone number is required and should be valid | Phone Number Validation Message if not accepted" class="help-block">Phone number is required and should be valid</div>
                                                     </div>
                                                     <button (click)="sendOTP()" class="form-control">
                                                        <span i18n="@@Reset Password | Reset Password Button">Reset Password</span>
                                                    </button>
                                                                </form>
    
  </div>
 </div>
 </div>
 </div>
 </div>
 </section>
 </div>
 

 <div *ngIf="otpSent">
 <div *ngIf="loaded">
<section class="login-main-wrapper">
            <div class="container-fluid pl-0 pr-0">
               <div class="row no-gutters row justify-content-center">
                  <div class="col-md-5 p-5 bg-dark-style full-height">
                      <div class="text-center mb-5 login-main-left-header">
                          <img src="assets/img/hostbrand/core-logo.svg" width="200" class="img-fluid" alt="LOGO">
                          
                            </div>
                       <div class="row">
                                    <div class="col-sm-12">
                                       <div class="form-group">
                                          <label i18n="@@Verification Code sent to your mobile phone | Message informing user that verification code is sent to their phone." class="control-label">Verification Code (Sent to your Cellphone)</label>
                                          <input (keyup)="onUUIDKeyUp($event)" class="form-control border-form-control" value="" placeholder="123456" type="text">
                                       </div>
                                    </div>
                                    
                                    <div class="col-sm-6">
                                       <div class="form-group">
                                          <label i18n="@@New Password | New Password Input" class="control-label">New Password* </label>
                                          <input minlength=6 (keyup)="onNewPasswordKeyUp($event)" class="form-control border-form-control" value="" placeholder="" type="text">
                                       </div>
                                       <div *ngIf="passShort" class="warning"><p i18n="@@Password too short | Password too short message">Password is too short, must be more than 6 characters in length</p></div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                           <label i18n="@@Type New Password Again | New Password Input Again" class="control-label">Type New Password Again* </label>
                                           <input minlength=6 (keyup)="onNewPasswordAgainKeyUp($event)" class="form-control border-form-control" value="" placeholder="" type="text">
                                        </div>
                                     </div>
                                     <div class="col-sm-12 mt-4">
                                    <button (click)="forgotUser()" class="form-control">
                                        <span i18n="@@Reset Password | Reset Password Button">Reset Password</span>
                                      </button></div>
                                    </div>
                                    <div class="text-center mt-5">
                                        <p class="light-gray"><span i18n="@@Already have an account? | Already have an account message">Take me back to login</span>
                                                <a i18n="@@Sign in | Sign in Link" routerLink="/login">  Sign In</a>
                                        </p>
                                </div>
                                    </div>
            </div>
            </div>
         </section>
         </div>
        </div>